import { InlineDatePicker } from "@/components/InlineDatePicker";
import { type OpportunitiesSearchFilters } from "@repo/api";
import { endOfDay } from "date-fns";

interface DatePickerProps {
  createdDate: OpportunitiesSearchFilters["createdDate"];
  onChange: (date: (Date | undefined)[]) => void;
  allowFutureDates?: boolean;
}

export const DatePicker = ({
  createdDate,
  onChange,
  allowFutureDates = false,
}: DatePickerProps) => {
  return (
    <InlineDatePicker
      id="created-date-filter"
      value={createdDate ?? []}
      allowFutureDates={allowFutureDates}
      onChange={(start, end) => {
        onChange([start, end && endOfDay(end)]);
      }}
    />
  );
};
